import React from "react";

const Frame = ({color, children}) => {
  return <div className={`frame grid-block`}>
    <div className={`framed-obj ${color ? color : 'gray'}`}>{children}</div>
  </div>
}

export default Frame
